/*eslint-disable */
const $ = window.jQuery = require('jquery');

import { Quill, VueEditor } from "vue2-editor";

import {
  bus
} from '@/main';
import notesConvertPdf from "./notes-convert-to-pdf/index.vue";
import notesView from "./notes-view-section/index.vue";
import sharedNotes from "./shared-notes/index.vue";

// Register fonts BEFORE component export
const Font = Quill.import('formats/font');
Font.whitelist = ['arial', 'georgia',  'tahoma', 'verdana'];
Quill.register(Font, true);

export default {
  name: 'notes',
  components: {
    'notes-share': sharedNotes,
    'notes-pdf': notesConvertPdf,
    'notes-view': notesView,
    VueEditor
  },
  props: [],
  data() {
    return {
      getAllNotesList: null,
      getAllNotesListResults: [],
      notesBoardInsert: false,
      createNotesData: '',
      createNotesTitle: '',
      updateNotesField: '',
      insertedNewNotesBoard: false,
      notesRemovedPopup: false,
      notesRemovedId: '',
      verticalAllNotesListState: false,
      notesDetailsUpdatedByIDstate: false,
      notesDetailsUpdatedByIdData: '',
      sharedNotesPopup: false,
      sharedNotesInfo: '',
      sharedNotesSection: false,
      sharedNotesList: null,
      sharedNotesListResults: [],
      sharedGroupNotesListResults: [],
      sharedNotesViewDetails: {},
      sharedNotesViewSection: false,
      coreSharedNotesSection: false,
      coreSharedNotesViewSection: false,
      selfUserId: '',
      keyUpEvent: false,
      submitted: false,
      notesConvertPdfState: false,
      notesConvertPdfData: {},
      notesViewPopup: false,
      notesViewData: '',
      editorOptions: {
        placeholder: 'Description...'
      },
      customToolbar: [
         [{ font: ['arial', 'georgia', 'tahoma', 'verdana'] }],
         ["bold", "italic", "underline", { color: [] }, { background: [] }]
      ],
      editorData: '',
      writeAccessSharedNotesViewSection: false,
      notesSearchState: '',
      noteCloseState: false,
      notesSearchResults: [],
      myNotesQuillInstance: null,
      sharedNotesQuillInstance: null,
      coreSharedNotesQuillInstance: null,
    }
  },
  computed: {

  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.getAllCreatedNotesListMethod()
    bus.$on('notesViewPopupBus', (data) => {
      this.notesViewPopup = data
      if (!this.notesViewPopup) {
        this.sharedNotesListMethod()
        this.getAgainAllNotesDetailsForUpdateMethod()
      }
    })
    bus.$on('sharedNotesBus', (data) => {
      this.sharedNotesPopup = data
    })
    bus.$on('notesConvertPdfStateBus', (data) => {
      this.notesConvertPdfState = data
    })
  },
  methods: {
    // Separate ready handlers for each editor
    onMyNotesEditorReady(quill) {
      this.myNotesQuillInstance = quill;
      quill.history.clear();
    },

    onSharedNotesEditorReady(quill) {
      this.sharedNotesQuillInstance = quill;
      quill.history.clear();
    },

    onCoreSharedNotesEditorReady(quill) {
      this.coreSharedNotesQuillInstance = quill;
      quill.history.clear();
    },
    clearNotesFilterMethod() {
      this.notesSearchState = '';
      this.noteCloseState = false;
      this.notesSearchResults = [];
    },
    notesSearchToKeywordMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            query: this.notesSearchState
          }
          this.$store.dispatch('notesSearchBarAction', data).then((res) => {
            this.notesSearchResults = res.data.data.results;
            this.noteCloseState = true;
            this.submitted = false;
          }).catch((err) => {
            this.submitted = false;
          })
        }
      })
    },
    sharedNotesIsReadMethod(Id) {
      let data = {
        user: this.selfUserId,
        grp_shared_notes: Id
      }
      this.$store.dispatch('isReadNotestStatusFun', data).then((res) => {
        this.sharedNotesListMethod();
      })
    },
    enabledNotesViewPopupMethod(data) {
      this.notesViewPopup = true;
      this.notesViewData = data;
      $('body').addClass('body_right_scroll_remove');
    },
    enabledConvertedPdfPopupMethod(data) {
      this.notesConvertPdfState = true;
      this.notesConvertPdfData = data;
    },
    backToMyNotesList() {
      this.sharedNotesViewSection = false;
      this.sharedNotesSection = false;
    },
    backToSharedNotesList() {
      this.sharedNotesViewSection = false;
    },
    backToCoreSharedNotesList() {
      this.coreSharedNotesViewSection = false;
      this.insertedNewNotesBoard = true;
    },
    viewCoreShareNotesInfoMethod(noteID, isRead, isReadID) {
      this.submitted = true;
      this.$store.dispatch('getNotesDetailsByIdFun', { id: noteID }).then((res) => {
        this.sharedNotesViewDetails = res.data.data;
        this.insertedNewNotesBoard = false;
        this.coreSharedNotesViewSection = true;
        this.submitted = false;
        if (isRead == false) {
          this.sharedNotesIsReadMethod(isReadID);
        }
      })
    },
    viewShareNotesInfoMethod(noteID, isRead, isReadID) {
      this.submitted = true;
      this.$store.dispatch('getNotesDetailsByIdFun', { id: noteID }).then((res) => {
        this.sharedNotesViewDetails = res.data.data;
        this.sharedNotesViewSection = true;
        this.submitted = false;
        if (isRead == false) {
          this.sharedNotesIsReadMethod(isReadID);
        }
      })
    },
    writeAccessNotesInfoMethod(noteID) {
      this.submitted = true;
      this.$store.dispatch('getNotesDetailsByIdFun', { id: noteID }).then((res) => {
        this.sharedNotesViewDetails = res.data.data;
        this.writeAccessSharedNotesViewSection = true;
        this.submitted = false;
      })
    },
    backToWriteAccessNotesList() {
      this.writeAccessSharedNotesViewSection = false;
      this.sharedNotesListMethod();
      this.coreSharedNotesViewSection = false;
    },
    showSharedUserListMethod() {
      if (this.sharedNotesSection == true) {
        this.sharedNotesSection = false;
      } else {
        this.sharedNotesSection = true;
        this.sharedNotesListMethod();
      }
      this.clearNotesFilterMethod();
    },
    showSharedUserListNewMethod() {
      if (this.coreSharedNotesSection == true) {
        this.coreSharedNotesSection = false;
      } else {
        this.coreSharedNotesSection = true;
        this.sharedNotesListMethod();
      }
    },
    sharedNotesPopupEnabledFun(data) {
      this.sharedNotesInfo = data;
      this.sharedNotesPopup = true;
      $('body').addClass('body_right_scroll_remove');
    },
    getAgainAllCreatedNotesListMethod() {
      this.sharedNotesSection = false;
      this.$store.dispatch('getAllNotesListFun').then((res) => {
        this.getAllNotesList = res.data.data;
        if (this.getAllNotesList != undefined) {
          this.getAllNotesListResults = this.getAllNotesList.results;
          if (this.getAllNotesListResults.length == 0) {
            this.verticalAllNotesListState = false;
            this.notesBoardInsert = false;
            this.insertedNewNotesBoard = true;
          }
        }
      })
    },
    getAgainAllNotesDetailsForUpdateMethod() {
      this.$store.dispatch('getAllNotesListFun').then((res) => {
        this.getAllNotesList = res.data.data;
        if (this.getAllNotesList != undefined) {
          this.getAllNotesListResults = this.getAllNotesList.results;
        }
      })
    },
    sharedNotesListMethod() {
      this.$store.dispatch('getAllSharedNotesListFun').then((res) => {
        this.sharedNotesList = res.data.data;
        if (this.sharedNotesList) {
          this.sharedNotesListResults = this.sharedNotesList.shared_notes;
          // this.sharedGroupNotesListResults = this.sharedNotesList.grp_shared_notes
        }
      })
    },
    getAllCreatedNotesListMethod() {
      this.$store.dispatch('getAllNotesListFun').then((res) => {
        this.getAllNotesList = res.data.data;
        if (this.getAllNotesList != undefined) {
          this.getAllNotesListResults = this.getAllNotesList.results;
          if (this.getAllNotesListResults.length > 0) {
            this.verticalAllNotesListState = true;
          } else {
            this.insertedNewNotesBoard = true;
            this.notesBoardInsert = false;
          }
        }
      })
    },
    updatedNotesDetailsByIdmethod(noteID) {
      this.submitted = true;
      this.$store.dispatch('getNotesDetailsByIdFun', { id: noteID }).then((res) => {
        this.verticalAllNotesListState = false;
        this.notesDetailsUpdatedByIDstate = true;
        this.notesDetailsUpdatedByIdData = res.data.data;
        this.submitted = false;
      })
    },
    disabledAllNotesListMethod() {
      this.verticalAllNotesListState = false;
    },
    enabledAllNotesListMethod() {
      this.notesDetailsUpdatedByIDstate = false;
      this.verticalAllNotesListState = true;
    },
    newInsertesNotesBoardMethod() {
      this.notesDetailsUpdatedByIDstate = false;
      this.verticalAllNotesListState = false;
      this.insertedNewNotesBoard = true;
      this.notesBoardInsert = true;
    },
    notesBoardInsertMethod() {
      if (this.notesBoardInsert === true) {
        this.notesBoardInsert = false;
      } else {
        this.notesBoardInsert = true;
        this.coreSharedNotesSection = false;
      }
    },
    savedInsertedNotesDataMethod() {
      if (this.createNotesData.length > 0) {
        let data = {
          data: this.createNotesData,
          title: this.createNotesTitle
        }
        this.$store.dispatch('createNewNotesDetailsFun', data).then((res) => {
          this.getAgainAllCreatedNotesListMethod();
          this.verticalAllNotesListState = true;
          this.createNotesData = '';
          this.createNotesTitle = '';
          this.insertedNewNotesBoard = false;
        }).catch((err) => {

        })
      } else {
        if (this.getAllNotesListResults.length > 0) {
          this.insertedNewNotesBoard = false;
          this.verticalAllNotesListState = true;
        } else {
          this.notesBoardInsert = false;
        }
      }
    },
    updatedInsertedNotesDataMethod(updateData, updateTitle, updateId) {
      let data = {
        data: updateData,
        title: updateTitle
      }
      this.$store.dispatch('updateNewNotesDetailsFun', { data: { data: data, id: updateId } }).then((res) => {
        this.updatedSharedNotesNotificationFalseMethod(updateId);
        this.sharedNotesListMethod();
        this.getAgainAllNotesDetailsForUpdateMethod();
      })
    },
    removedInsertedNotesDataMethod(removeId) {
      this.notesRemovedId = removeId;
      this.notesRemovedPopup = true;
      $('body').addClass('body_right_scroll_remove');
    },
    removeModalItemConfirmFun() {
      this.$store.dispatch('deleteNewNotesDetailsFun', { id: this.notesRemovedId }).then((res) => {
        this.closeRemoveItemModalFun();
        this.getAgainAllCreatedNotesListMethod();
      })
    },
    closeRemoveItemModalFun() {
      this.notesRemovedId = '';
      this.notesRemovedPopup = false;
      this.notesDetailsUpdatedByIDstate = false;
      this.verticalAllNotesListState = true;
      $('body').removeClass('body_right_scroll_remove');
    },
    updatedSharedNotesNotificationMethod(updateId) {
      if (this.keyUpEvent) return;
      let data = {
        under_editing: true,
        edited_by: this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun', { data: { data: data, id: updateId } }).then((res) => {
        this.keyUpEvent = true;
      })
      // Clear history based on which section is active
      this.$nextTick(() => {
        if (this.notesDetailsUpdatedByIDstate && this.myNotesQuillInstance) {
          this.myNotesQuillInstance.history.clear();
        } else if (this.sharedNotesViewSection && this.sharedNotesQuillInstance) {
          this.sharedNotesQuillInstance.history.clear();
        } else if (this.coreSharedNotesViewSection && this.coreSharedNotesQuillInstance) {
          this.coreSharedNotesQuillInstance.history.clear();
        }
      });
    },
    updatedSharedNotesNotificationFalseMethod(updateId) {
      let data = {
        under_editing: false,
        edited_by: this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun', { data: { data: data, id: updateId } }).then((res) => {
        this.keyUpEvent = false;
      })
      // Clear all instances
      this.$nextTick(() => {
        if (this.myNotesQuillInstance) {
          this.myNotesQuillInstance.history.clear();
        }
        if (this.sharedNotesQuillInstance) {
          this.sharedNotesQuillInstance.history.clear();
        }
        if (this.coreSharedNotesQuillInstance) {
          this.coreSharedNotesQuillInstance.history.clear();
        }
      });
    },
  },
  watch: {
    'notesDetailsUpdatedByIdData.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.$nextTick(() => {
          if (this.myNotesQuillInstance) {
            this.myNotesQuillInstance.history.clear();
          }
        });
      }
    },

    'sharedNotesViewDetails.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.$nextTick(() => {
          if (this.sharedNotesQuillInstance) {
            this.sharedNotesQuillInstance.history.clear();
          }
          if (this.coreSharedNotesQuillInstance) {
            this.coreSharedNotesQuillInstance.history.clear();
          }
        });
      }
    }
  }
}